import { store } from '@store';

import {
    MeatballButton,
    MeatballMenuDirection,
    MeatballModifier,
    MeatballThemes,
} from '@components/ActionButtons/MeatballButton';
import { useChangeLanguage } from './useChangeLanguage';

export function ChangeLanguageButton() {
    const { locale, makeMeatballItems } = useChangeLanguage(store);
    const items = makeMeatballItems();
    return (
        <MeatballButton
            // @ts-expect-error
            label={locale}
            items={items}
            theme={MeatballThemes.Light}
            direction={MeatballMenuDirection.Right}
            modifiers={[MeatballModifier.Tiny, MeatballModifier.Bordered]}
        />
    );
}
